import { Link } from 'react-router-dom';
import './styles/NoMatch.scss'
import Seo from '../../components/Seo';

export default function NoMatch() {
    return (
        <div className="noMatch">
            <Seo title="Stránka nenalezena" noindex />
            <span className="code">404</span>
            <h1>Stránka nenalezena</h1>
            <p>Omlouváme se, tahle stránka neexistuje nebo byla přesunuta.</p>
            <Link to="/" className="homeLink">Zpět na úvod</Link>
        </div>
    );
}
